import { useState } from 'react';

import NumericInput from '../../../../shared/components/numeric-input/numeric-input';
import SurveyAnswer from '../../../../shared/models/survey/SurveyAnswer';
import { SurveySliderQuestionType } from '../SurveyQuestionTypes';

import '../SurveyQuestion.scss';

type PropType = SurveySliderQuestionType & {
  id: string;
  onSelectAnswer: (answer: SurveyAnswer) => void;
  previousAnswer: number | undefined;
  bem: (element: string) => string;
  identifier: string;
};

const SurveyInputQuestion = ({
  bem,
  id,
  minValue,
  maxValue,
  onSelectAnswer,
  previousAnswer,
  suffix,
  identifier,
}: PropType) => {
  const [selectedAnswer, setSelectedAnswer] = useState<number>(previousAnswer ?? minValue);

  const decimalAllowedIdentifiers = ['Beweging'];
  const allowDecimals = identifier ? decimalAllowedIdentifiers.includes(identifier) : false;

  const handleOnChange = (v: number) => {
    setSelectedAnswer(v);

    onSelectAnswer({
      value: v,
      questionId: id,
    });
  };

  return (
    <div className={bem('numeric')}>
      <NumericInput
        min={minValue}
        max={maxValue}
        value={selectedAnswer}
        onChange={(value) => {
          handleOnChange(value);
        }}
        aria-labelledby={id}
        instantUpdate
        allowDecimals={allowDecimals}
      />
      {suffix && <p className={`${bem('suffix')} caption`}>{suffix}</p>}
    </div>
  );
};

export default SurveyInputQuestion;
